import type {DependencyList, ReactElement} from 'react';
import { useEffect} from 'react';
import {updatePanelPropsForModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {useAppDispatch} from '@/hooks';
import {useModalData} from '@Components/modal/hooks/useModalData';

export const useUpdateMoreOptionsModal = (updatedContent: ReactElement<any>, dependencyArray: DependencyList): void => {
  const modalData = useModalData(MODALS_IDS.MORE_OPTIONS_MODAL);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!modalData) {
      return;
    }

    dispatch(updatePanelPropsForModal({
      modalId: MODALS_IDS.MORE_OPTIONS_MODAL,
      panelProps: {
        ...modalData.panelProps,
        content: updatedContent
      }
    }));
  }, dependencyArray);
};
